const defaultPriorities = [
    { id: 1, color: "#FF5252", label: "high" },
    { id: 2, color: "#FFC975", label: "medium" },
    { id: 3, color: "#0AB169", label: "low" },
];
const defaultColors = ["#65D3B3", "#FFC975", "#58C3FE"];
export const defaultCardShape = {
    label: {
        show: true,
    },
    description: {
        show: false,
    },
    progress: {
        show: false,
    },
    start_date: {
        show: false,
    },
    end_date: {
        show: false,
    },
    users: {
        show: false,
    },
    priority: {
        show: false,
        values: defaultPriorities,
    },
    color: {
        show: false,
        values: defaultColors,
    },
    cover: {
        show: false,
    },
    attached: {
        show: false,
    },
    menu: {
        show: true,
    },
};
export const defaultEditorShape = [
    {
        key: "label",
        type: "text",
        label: "Label",
    },
    {
        key: "description",
        type: "textarea",
        label: "Description",
    },
    {
        type: "combo",
        label: "Priority",
        key: "priority",
    },
    {
        type: "color",
        label: "Color",
        key: "color",
    },
    {
        type: "progress",
        key: "progress",
        label: "Progress",
    },
    {
        type: "date",
        key: "start_date",
        label: "Start date",
    },
    {
        type: "date",
        key: "end_date",
        label: "End date",
    },
];
export const defaultEditorConfig = {
    debounce: 100,
    autoSave: true,
};
export const elementsIds = {
    kanban: "wx-kanban",
    toolbar: "wx-kanban-toolbar",
    editor: "wx-kanban-editor",
    content: "wx-kanban-content",
    scrollableContent: "wx-kanban-scrollable-content",
};
export const customIcons = {
    "wxi-arrow-right": {
        path: "M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z",
    },
    "wxi-arrow-left": {
        path: "M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z",
    },
    "wxi-arrow-up": {
        path: "M13,20H11V8L5.5,13.5L4.08,12.08L12,4.16L19.92,12.08L18.5,13.5L13,8V20Z",
    },
    "wxi-arrow-down": {
        path: "M11,4H13V16L18.5,10.5L19.92,11.92L12,19.84L4.08,11.92L5.5,10.5L11,16V4Z",
    },
    "wxi-sort": {
        path: "M18 21L14 17H17V7H14L18 3L22 7H19V17H22M2 19V17H12V19M2 13V11H9V13M2 7V5H6V7H2Z",
    },
    "wxi-sort-ascending": {
        path: "M19 17H22L18 21L14 17H17V3H19M2 17H12V19H2M6 5V7H2V5M2 11H9V13H2V11Z",
    },
    "wxi-sort-descending": {
        path: "M19 7H22L18 3L14 7H17V21H19M2 17H12V19H2M6 5V7H2V5M2 11H9V13H2V11Z",
    },
    "wxi-undo": {
        path: "M12.5,8C9.85,8 7.45,9 5.6,10.6L2,7V16H11L7.38,12.38C8.77,11.22 10.54,10.5 12.5,10.5C16.04,10.5 19.05,12.81 20.1,16L22.47,15.22C21.08,11.03 17.15,8 12.5,8Z",
    },
    "wxi-redo": {
        path: "M18.4,10.6C16.55,9 14.15,8 11.5,8C6.85,8 2.92,11.03 1.54,15.22L3.9,16C4.95,12.81 7.95,10.5 11.5,10.5C13.45,10.5 15.23,11.22 16.62,12.38L13,16H22V7L18.4,10.6Z",
    },
};
export const getSortConfig = () => {
    return [
        {
            by: "label",
            dir: "asc",
            label: "Label (a-z)",
            id: 7,
        },
        {
            by: "label",
            dir: "desc",
            label: "Label (z-a)",
            id: 8,
        },
        {
            by: "description",
            dir: "asc",
            label: "Description (a-z)",
            id: 9,
        },
        {
            by: "description",
            dir: "desc",
            label: "Description (z-a)",
            id: 10,
        },
    ];
};
export const getDefaultCardMenuItems = ({ store }) => {
    const { readonly } = store.getState();
    const baseItems = [
        { id: "duplicate-card", icon: "wxi-content-copy", label: "Duplicate" },
        { id: "delete-card", icon: "wxi-delete", label: "Delete" },
    ];
    if (!readonly?.select && readonly?.edit) {
        return [
            { id: "set-edit", icon: "wxi-edit", label: "Edit" },
            ...baseItems,
        ];
    }
    return baseItems;
};
export const getDefaultColumnMenuItems = ({ columns, columnIndex, }) => [
    { id: "add-card", icon: "wxi-plus", label: "Add new card" },
    { id: "set-edit", icon: "wxi-edit", label: "Rename" },
    {
        id: "move-column:left",
        icon: "wxi-arrow-left",
        label: "Move left",
        disabled: columnIndex <= 0,
    },
    {
        id: "move-column:right",
        icon: "wxi-arrow-right",
        label: "Move right",
        disabled: columnIndex >= columns.length - 1,
    },
    { id: "delete-column", icon: "wxi-delete", label: "Delete" },
];
export const getDefaultRowMenuItems = ({ rows, rowIndex, }) => [
    { id: "set-edit", icon: "wxi-edit", label: "Rename" },
    {
        id: "move-row:up",
        icon: "wxi-arrow-up",
        label: "Move up",
        disabled: rowIndex <= 0,
    },
    {
        id: "move-row:down",
        icon: "wxi-arrow-down",
        label: "Move down",
        disabled: rowIndex >= rows.length - 1,
    },
    { id: "delete-row", icon: "wxi-delete", label: "Delete" },
];
//# sourceMappingURL=constants.js.map